import { createSlice } from '@reduxjs/toolkit';

import { getManageShipments, confirmShipment } from '../../apis';

export const ManageShipmentsSlice = createSlice({
    name: 'newOrders',
    initialState: {
        isLoading: false,
        data : [],
        error: '',
        confirmShipment: false,
        confirmShipmentLoading: false
    },

    reducers: {
        updateShipmentStyleRowData: (state, action) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    current_shipment: [...(state.data.current_shipment.filter(item => item.style_id !== action.payload.style_id)), action.payload]
                }
            }
        },
    },

    extraReducers: (builder) => {
        builder.addCase(getManageShipments.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getManageShipments.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getManageShipments.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(confirmShipment.pending, (state, action) => {
            state.confirmShipment = false;
            state.confirmShipmentLoading = true;
        })
        builder.addCase(confirmShipment.fulfilled, (state, action) => {
            state.confirmShipment = true;
            state.error = '';
            state.confirmShipmentLoading = true;
        })
        builder.addCase(confirmShipment.rejected, (state, action) => {
            state.confirmShipment = false;
            state.error = action.payload.message
            state.confirmShipmentLoading = false;
        })
    }
})

export const { updateShipmentStyleRowData } = ManageShipmentsSlice.actions


export default ManageShipmentsSlice.reducer